import Window from "../../components/Window";
import styles from "./styles.jsx";
import Button from "../../widgets/Button";
import TextInput from "../../widgets/TextInput";
import TouchableOpacity from "../../widgets/TouchableOpacity";
import { DatePicker } from "antd";
import { useState, useRef, useEffect, useCallback } from "react";
import { themeColors } from "../../config";
import {
  CheckOutlined,
  DeleteOutlined,
  SaveOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { formatDate } from "../../utils.js";

const Note = ({ note, index, onCancel, saveNote, setNoteSize, setNotePos }) => {
  const [saved, setSaved] = useState(true);
  const textBox = useRef();
  useEffect(() => {
    if (textBox.current) {
      textBox.current.innerText = note.content;
    }
  }, []);
  const handleSaveNote = () => {
    setSaved(true);
    saveNote(textBox.current.innerText, index);
  };
  return (
    <Window
      id={"note-" + note.id}
      top={note.pos.y}
      left={note.pos.x}
      name={note.title + (saved ? " ●" : " ○")}
      onCancel={onCancel}
      minWidth={120}
      minHeight={50}
      height={note.size.h}
      width={note.size.w}
      onFinishResize={(w, h) => {
        setNoteSize({ w, h }, index);
      }}
      onFinishDrag={(x, y) => {
        setNotePos({ x, y }, index);
      }}
    >
      <div style={styles.noteMenu}>
        <TouchableOpacity style={styles.menuButton} onClick={handleSaveNote}>
          <SaveOutlined />
        </TouchableOpacity>
      </div>
      <div
        ref={(ref) => (textBox.current = ref)}
        style={styles.noteContent}
        contentEditable
        onInput={() => setSaved(false)}
      ></div>
    </Window>
  );
};

const NoteRow = ({
  note,
  index,
  toggleNoteActive,
  toggleNoteOpen,
  deleteNote,
}) => {
  const dateObj = formatDate(new Date(note.date));
  return (
    <div style={{ ...styles.noteRow, opacity: note.active ? 1 : 0.5 }}>
      <TouchableOpacity
        style={styles.titleCol}
        onClick={() => toggleNoteOpen(index)}
      >
        <div style={styles.title}>{note.title}</div>
        <div style={styles.date}>
          {dateObj.year +
            "-" +
            dateObj.month +
            "-" +
            dateObj.day +
            " " +
            dateObj.hour +
            ":" +
            dateObj.minute}
        </div>
      </TouchableOpacity>
      <div style={styles.controlBtn}>
        <Button
          style={{ margin: 5 }}
          onClick={() => {
            toggleNoteActive(index);
          }}
        >
          <CheckOutlined
            style={{
              color: note.active
                ? themeColors.transparentBlack
                : themeColors.green,
            }}
          />
        </Button>
        <Button
          style={{ margin: 5, backgroundColor: themeColors.red }}
          onClick={() => {
            deleteNote(index);
          }}
        >
          <DeleteOutlined />
        </Button>
      </div>
    </div>
  );
};

const NotesApp = ({ setOpen, systemData, updateSystemData }) => {
  const noteObj = systemData ? systemData.notes : { notes: [] };
  const notes = noteObj ? noteObj.notes : [];
  const [date, setDate] = useState();
  const [title, setTitle] = useState("");
  const noteRef = useRef(notes);

  const setNotes = (notes) => {
    updateSystemData({
      notes: {
        notes: JSON.parse(JSON.stringify(notes)),
      },
    });
    noteRef.current = notes;
  };

  const addNote = () => {
    const newNotes = JSON.parse(JSON.stringify(notes));
    newNotes.push({
      title,
      content: "",
      active: true,
      open: false,
      pos: { x: 0, y: 0 },
      size: { w: 200, h: 200 },
      date: new Date(date),
    });
    setNotes(newNotes);
  };

  const toggleNoteActive = (index) => {
    const newNotes = [...noteRef.current];
    newNotes[index].active = !newNotes[index].active;
    setNotes(newNotes);
  };
  const toggleNoteOpen = (index) => {
    const newNotes = [...noteRef.current];
    newNotes[index].open = !newNotes[index].open;
    setNotes(newNotes);
  };
  const deleteNote = (index) => {
    const newNotes = [...noteRef.current];
    newNotes.splice(index, 1);
    setNotes(newNotes);
  };
  const saveNote = (note, index) => {
    const newNotes = [...noteRef.current];
    newNotes[index].content = note;
    setNotes(newNotes);
  };

  const setNoteSize = (size, index) => {
    const newNotes = [...noteRef.current];
    newNotes[index].size = size;
    setNotes(newNotes);
  };

  const setNotePos = (pos, index) => {
    const newNotes = [...noteRef.current];
    newNotes[index].pos = pos;
    console.log(newNotes);
    setNotes(newNotes);
  };

  const noteWindows = [];
  const noteList = [];
  notes.map((note, index) => {
    noteList.push(
      <NoteRow
        key={note.title}
        index={index}
        note={note}
        toggleNoteActive={toggleNoteActive}
        toggleNoteOpen={toggleNoteOpen}
        deleteNote={deleteNote}
      />
    );
    if (note.open)
      noteWindows.push(
        <Note
          key={note.title}
          index={index}
          saveNote={saveNote}
          setNoteSize={setNoteSize}
          setNotePos={setNotePos}
          note={note}
          onCancel={() => toggleNoteOpen(index)}
        />
      );
  });
  return (
    <div>
      <Window
        id={"notes"}
        top={0}
        left={0}
        name={"Notes"}
        onCancel={() => setOpen(false)}
      >
        <div style={styles.component}>
          <div style={{ ...styles.full, justifyContent: "flex-start" }}>
            {noteList}
            <div style={styles.noteRow}>
              <TextInput
                value={title}
                onChange={setTitle}
                placeholder={"title"}
                style={{
                  color: themeColors.optionColor,
                  border: "1px solid white",
                  borderRadius: 2,
                  margin: 5,
                  fontSize: 14,
                }}
              />
              <div style={{ margin: 5 }}>
                <DatePicker
                  value={date}
                  onOk={setDate}
                  onChange={setDate}
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  size={"small"}
                  placeholder={"date"}
                />
              </div>

              <Button
                style={{ margin: 10, backgroundColor: themeColors.green }}
                onClick={addNote}
              >
                <PlusOutlined />
              </Button>
            </div>
          </div>
        </div>
      </Window>
      {noteWindows}
    </div>
  );
};

export default NotesApp;
